import { CommonHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const INITIAL_STATE = {
  isArrayLoading: false,
  isArrayLoaded: false,
  arrayData: [],
  message: '',
};

const getOrgGroupTypes = (state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);
    const url = `/OrgGroup/types`;
    CommonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const OrgGroupTypesData = { INITIAL_STATE, getOrgGroupTypes };
export default OrgGroupTypesData;